module.exports = __webpack_public_path__ + "b51f10c2.png";